<div class="page-title-container">
	<div class="page-title">
		{{ title }}
	</div>
	<hr class="page-title-underline" />
</div>
